module.exports = __webpack_public_path__ + "assets/images/xjxUFUm9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/analysis-pages.png
// module id = 1132
// module chunks = 0